import React from "react";
import styled from "styled-components";
import { media } from "styled-bootstrap-grid";

const H1 = styled.h1`
	font-size: 2rem;
  margin-bottom: 20px;
	font-family: "Sharp Medium", sans-serif;

	${media.lg`
		font-size: 80px;
  `}
  ${media.lg`
		font-family: "Sharp", sans-serif;
		margin-bottom: 40px;
		font-size: 120px;
  `}
`

const H2 = styled.h2`
  font-size: 24px;
  margin-bottom: 20px;
	font-family: "Sharp Medium", sans-serif;
  ${media.lg`
		padding-bottom: 0.5rem;
		font-size: 32px;
  `}
`;

const P = styled.p`
	font-size: 16px;
	line-height: 1.8;
	b {
		font-family: "Sharp Medium", sans-serif;
	}
`

export const Headline1 = ({ className, children }) => {
  return <H1 className={className}>{children}</H1>;
};

export const Headline2 = ({ className, children }) => {
  return <H2 className={className}>{children}</H2>;
};

export const Paragraph = ({ className, children }) => {
  return <P className={className}>{children}</P>;
};

